
import React from 'react';
import { cn } from '@/lib/utils';
import { Label } from './label';
import type { LabelProps } from '@radix-ui/react-label';

interface LabelWithChildrenProps extends React.ComponentPropsWithoutRef<typeof Label> {
  children: React.ReactNode;
}

export const LabelWithChildren = React.forwardRef<
  HTMLLabelElement,
  LabelWithChildrenProps
>(({ className, children, ...props }, ref) => (
  <Label ref={ref} className={cn(className)} {...props}>
    {children}
  </Label>
));

LabelWithChildren.displayName = 'LabelWithChildren';
